import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  &:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  font-size: ", ";\n  padding: ", " ", ";\n  text-align: left;\n  text-decoration: none;\n  transition: background-color ", ", color ", ";\n  white-space: nowrap;\n  width: 100%;\n\n  &:hover {\n    background-color: ", ";\n    text-decoration: none;\n  }\n\n  &:first-child {\n    margin-top: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { property, color, typography } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { baselineToPx, rem } from '@scp/ui-shared/theme/utils';
import { Paragraph } from '@scp/ui-shared/components/typography';
var E2E_SUFFIX = '-select-menu-item';
var Item = styled(LinkOrButton)(_templateObject(), color.palette.white, color.textPrimary, rem(typography.defaultFontSize), baselineToPx(2), baselineToPx(4), property.transition, property.transition, color.palette.grey900, baselineToPx(2), baselineToPx(2));
var ItemWithRipple = withRippleEffect(Item);
var Label = styled(Paragraph).attrs({
  as: 'span',
  noMargin: true
})(_templateObject2(), ellipsis(), baselineToPx(3));
var ActiveIcon = styled(Icon).attrs({
  name: 'check',
  size: 20,
  color: color.action
})(_templateObject3());
var ItemIcon = styled(Icon).attrs({
  size: 20,
  color: color.textPrimary
})(_templateObject4(), baselineToPx(2));
export var SelectMenuItem = function SelectMenuItem(_a) {
  var iconName = _a.iconName,
      children = _a.children,
      active = _a.active,
      dataE2e = _a.dataE2e,
      otherProps = __rest(_a, ["iconName", "children", "active", "dataE2e"]);

  return React.createElement(ItemWithRipple, Object.assign({}, otherProps, {
    dataE2e: getE2eLabel(children, E2E_SUFFIX, dataE2e),
    "aria-pressed": active
  }), iconName && React.createElement(ItemIcon, {
    name: iconName
  }), React.createElement(Label, null, children), active && React.createElement(ActiveIcon, {
    name: "check",
    size: 20,
    color: color.action
  }));
};